///<reference path="../model/Sunrise.ts"/>
///<reference path="../model/TideName.ts"/>
///<reference path="../model/TideTime.ts"/>

namespace app.view{
	import TideTime = app.model.TideTime;
	import TideName = app.model.TideName;
	import Sunrise = app.model.Sunrise;

	export class ChosekiView{
		public tideTime:TideTime;
		public tideName:TideName;
		public sunrise:Sunrise;
		private locationName:string;

		constructor(location){
			let dic = {
				"hamanako":"浜名湖",
				"shimizu":"清水港",
				"omaezaki":"御前崎",
				"itou":"伊東"
			};

			this.locationName = dic[location];

		}

		private getTideDate(i):string{
			return this.tideTime.data[i].date.toString(Const.DATE_DEFAULT);
		}

		private getTideHigh(i){
			return this.tideTime.data[i].high.join(`<br />`);
		}

		private getTideLow(i){
			return this.tideTime.data[i].low.join(`<br />`);
		}
		private getTideName(i){
			return this.tideName.data[i].name;
		}
		private getSunrise(i){
			return this.sunrise.data[i].sunrise;
		}
		private getSunset(i){
			return this.sunrise.data[i].sunset;
		}

		public makeData():string{
			let str = `
<div class="choseki">
<h2>${this.locationName}</h2>
<table>
	<tr>
		<th>日付</th>
		<td>${this.getTideDate(0)}</td>
		<td>${this.getTideDate(1)}</td>
		<td>${this.getTideDate(2)}</td>
		<td>${this.getTideDate(3)}</td>
		<td>${this.getTideDate(4)}</td>
		<td>${this.getTideDate(5)}</td>
		<td>${this.getTideDate(6)}</td>
	</tr>
	<tr>
		<th>満潮</th>
		<td>${this.getTideHigh(0)}</td>
		<td>${this.getTideHigh(1)}</td>
		<td>${this.getTideHigh(2)}</td>
		<td>${this.getTideHigh(3)}</td>
		<td>${this.getTideHigh(4)}</td>
		<td>${this.getTideHigh(5)}</td>
		<td>${this.getTideHigh(6)}</td>
	</tr>
	<tr>
		<th>干潮</th>
		<td>${this.getTideLow(0)}</td>
		<td>${this.getTideLow(1)}</td>
		<td>${this.getTideLow(2)}</td>
		<td>${this.getTideLow(3)}</td>
		<td>${this.getTideLow(4)}</td>
		<td>${this.getTideLow(5)}</td>
		<td>${this.getTideLow(6)}</td>
	</tr>
	<tr>
		<th>潮</th>
		<td>${this.getTideName(0)}</td>
		<td>${this.getTideName(1)}</td>
		<td>${this.getTideName(2)}</td>
		<td>${this.getTideName(3)}</td>
		<td>${this.getTideName(4)}</td>
		<td>${this.getTideName(5)}</td>
		<td>${this.getTideName(6)}</td>
	</tr>
</table>
</div>
<div class="sun">
<table>
	<tr>
		<th>日付</th>
		<td>${this.getTideDate(0)}</td>
		<td>${this.getTideDate(1)}</td>
	</tr>
	<tr>
		<th>日の出</th>
		<td>${this.getSunrise(0)}</td>
		<td>${this.getSunrise(1)}</td>
	</tr>
	<tr>
		<th>日の入り</th>
		<td>${this.getSunset(0)}</td>
		<td>${this.getSunset(1)}</td>
	</tr>
</table>
</div>
`;
			return str;
		}

		public makeError():string{
			let str = `<p>データの取得に失敗しました</p>`;
			return str;
		}

	}

}

